/**
 *
 * @param from Date (most recent)
 * @param to Date (in the past)
 * @returns Time elapsed from oldest date (to) to recent date (from)
 */
export function timeGetDiff(
  from: Date,
  to: Date
): { years: number; months: number; days: number; hours: number; minutes: number; seconds: number } {
  if (to.getTime() > from.getTime()) {
    return;
  }

  const fromYear = from.getFullYear();
  const fromMonth = from.getMonth() + 1;
  const fromDay = from.getDate();
  const fromHours = from.getHours();
  const fromMinutes = from.getMinutes();
  const fromSeconds = from.getSeconds();

  const toYear = to.getFullYear();
  const toMonth = to.getMonth() + 1;
  const toDay = to.getDate();
  const toHours = to.getHours();
  const toMinutes = to.getMinutes();
  const toSeconds = to.getSeconds();

  const daysInFromMonth = new Date(fromYear, fromMonth, 0).getDate();

  let years: number = fromYear - toYear;
  let months: number;
  let days: number;
  let hours: number;
  let minutes: number;
  let seconds: number;

  const checkMonths = () => {
    if (months - 1 < 0) {
      years--;
      months = 11;
    } else {
      months--;
    }
  };
  const checkDays = () => {
    if (days - 1 < 0) {
      days = daysInFromMonth - 1;
      checkMonths();
    } else {
      days--;
    }
  };
  const checkHours = () => {
    if (hours - 1 < 0) {
      hours = 23;
      checkDays();
    } else {
      hours--;
    }
  };
  const checkMinutes = () => {
    if (minutes - 1 < 0) {
      minutes = 59;
      checkHours();
    } else {
      minutes--;
    }
  };

  if (fromMonth >= toMonth) {
    months = fromMonth - toMonth;
  } else {
    months = fromMonth + 12 - toMonth;
    years--;
  }
  if (fromDay >= toDay) {
    days = fromDay - toDay;
  } else {
    days = daysInFromMonth - toDay + fromDay;
    checkMonths();
  }
  if (fromHours >= toHours) {
    hours = fromHours - toHours;
  } else {
    hours = 24 - toHours + fromHours;
    checkDays();
  }
  if (fromMinutes >= toMinutes) {
    minutes = fromMinutes - toMinutes;
  } else {
    minutes = 60 - toMinutes + fromMinutes;
    checkHours();
  }
  if (fromSeconds >= toSeconds) {
    seconds = fromSeconds - toSeconds;
  } else {
    seconds = 60 - toSeconds + fromSeconds;
    checkMinutes();
  }

  return {
    years,
    months,
    days,
    hours,
    minutes,
    seconds,
  };
}
